import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  ConfirmFeederContractModel,
  FeederContractModel
} from '@bo-client/activation-management/feeder-contract/model/feeder-contract.model';
import { RequestFormBase } from '@bo-client/shared/base-components/request-form.base';
import { HttpHapService } from '@bo-client/core/http/http-hap.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { FeederContractRequestService } from '@bo-client/activation-management/feeder-contract/feeder-contract-request.service';
import { uri } from '@bo-client/shared/constants/uri';
import { ConfirmationRequestPageBase } from '@bo-client/shared/base-components/confirmation-request-page.base';
import { Subject } from 'rxjs';
import { RequestApprovalDto } from '@bo-client/activation-management/grid-registration/model/RequestApprovalDto';
import { ConfigService } from '@bo-client/config/config.service';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { takeUntil } from 'rxjs/operators';
import { LoadDataFormsGridRegistrationService } from '@bo-client/activation-management/shared/services/load-data-forms-grid-registration.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-fc-contract-confirmation',
  templateUrl: './fc-contract-confirmation.component.html',
  styleUrls: ['./fc-contract-confirmation.component.scss']
})
export class FcContractConfirmationComponent
  extends ConfirmationRequestPageBase<FeederContractModel>
  implements OnInit, OnDestroy
{
  @ViewChild('form')
  public form: RequestFormBase<FeederContractModel>;
  public uriGetData = uri.cmFeederContractExternal;
  public requestApprovalDto: RequestApprovalDto;
  public compUnsubs$ = new Subject<void>();
  public actions = this.feederContractService.actions;

  public feederContract: FeederContractModel = null;

  public contractType: string;

  get withoutExplicitContract() {
    return this.dataShareService.tenantConfig.feederContract?.withoutExplicitContractDocument;
  }

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected httpService: HttpHapService,
    protected toastService: ToastrService,
    protected matDialog: MatDialog,
    protected feederContractService: FeederContractRequestService,
    public dataShareService: DataShareService,
    private configService: ConfigService,
    private httpHapService: HttpHapService,
    private loadDataFormsGridRegistrationService: LoadDataFormsGridRegistrationService
  ) {
    super(route, router, httpService, toastService, matDialog);
    this.title = 'Einspeiser Vertrag Anfrage für Kunden';
  }

  ngOnInit() {
    super.init();
  }

  hookDataLoaded() {
    // entry Point after standard loading data
    this.feederContract = this.model;
    this.contractType = this.feederContract.contractType;
  }

  hookGetDataFromForm() {
    // entry Point to modify additionalData to save
    // in base Component additionaldata is loaded with the form structure
    // this.requestApprovalDto.additionalData = {....}
    this.requestApprovalDto.additionalData = this.requestApprovalDto
      .additionalData as ConfirmFeederContractModel;
    this.requestApprovalDto.additionalData.invoiceContact = this.requestApprovalDto.additionalData
      ? this.requestApprovalDto.additionalData.invoiceContact[0]
      : null;
  }

  generateDocument() {
    if (!this.form.isValid()) {
      return;
    }
    this.model = this.loadDataFormsGridRegistrationService.loadFeederContractConfirmContractByCustomer(
      this.model,
      this.form.getFormGroup()
    );
    this.httpHapService
      .postPdf(
        this.model,
        uri.cmFeederContractExternalPreview +
          `?feederContractId=${this.model.id}&feederContractToken=${this.model.customerToken}&tenant=thn&template=FEEDER_CONTRACT&targetType=application/pdf`
      )
      .pipe(takeUntil(this.compUnsubs$))
      .subscribe(
        (data: Blob) => {
          const file = new Blob([data], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          // if you want to open PDF in new tab
          window.open(fileURL);
        },
        (error) => {
          console.log('getPDF error: ', error.message);
        }
      );
  }

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
